<section class="skeleton-loader d-md-block d-none">
    <!-- banner section -->
    <article class="banner">
        <ngx-skeleton-loader
            count="1"
            animation="pulse"
            [theme]="{ 
            'border-radius': '8px',
            height: '90vh',
            width: '100%',
            'background-color': '#E4E6ED'
            }"
        ></ngx-skeleton-loader>
    </article>
    <article class="banner__content">
        <!-- banner header -->
        <div class="banner__header w-100 text-center mb-5">
            <ngx-skeleton-loader
            count="1"
            animation="progress"
            [theme]="{ 
            'border-radius': '8px',
            height: '60px',
            width: '45%',
            'background-color': '#edeef2'
            }"
            ></ngx-skeleton-loader>
        </div>
        <!-- banner description -->
        <div class="banner__description w-100 text-center mb-5">
            <ngx-skeleton-loader
            count="1"
            animation="progress"
            [theme]="{ 
            'border-radius': '4px',
            height: '18px',
            width: '50%',
            display: 'block',
            margin: 'auto',
            'margin-bottom': '15px',
            'background-color': '#edeef2'
            }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
            count="1"
            animation="progress"
            [theme]="{ 
            'border-radius': '4px',
            height: '18px',
            width: '30%',
            'background-color': '#edeef2'
            }"
            ></ngx-skeleton-loader>
        </div>
        <div class="banner__buttons row d-flex justify-content-center w-100">
            <div class="col-lg-2 col-md-4 p-0 mr-4">
                <ngx-skeleton-loader
                count="1"
                animation="progress"
                [theme]="{
                'border-radius': '0',
                height: '44px',
                width: '100%',
                'background-color': '#edeef2'
                }"
                ></ngx-skeleton-loader>
            </div>
            <div class="col-lg-2 col-md-4 p-0">
                <ngx-skeleton-loader
                count="1"
                animation="progress"
                [theme]="{
                'border-radius': '0',
                height: '44px',
                width: '100%',
                'background-color': '#edeef2'
                }"
                ></ngx-skeleton-loader>
            </div>
        </div>
    </article>
    <!-- odd section -->
    <article class="section px-4 py-5">
        <div class="container h-100">
            <div class="row h-100">
                <article class="section__content col-xl-4 col-lg-5">
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '50px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="4"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '100%',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <!-- section button -->
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '0',
                        height: '44px',
                        width: '50%',
                        'margin-top': '50px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                </article>
                <article class="section__image col-xl-8 col-lg-7">
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-lg-block d-none">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '375px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                    <div class="mr-lg-4 mt-lg-0 mt-5 d-lg-none d-md-block">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '300px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                </article>
            </div>
        </div>
    </article>
    <!-- even section -->
    <article class="section section--even px-4 py-5">
        <div class="container h-100">
            <div class="row h-100">
                <article class="section__content col-xl-4 col-lg-5 order-lg-2">
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '50px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#edeef2'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="4"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '100%',
                        'background-color': '#edeef2'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#edeef2'
                        }"
                    ></ngx-skeleton-loader>
                    <!-- section button -->
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '0',
                        height: '44px',
                        width: '50%',
                        'margin-top': '50px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                </article>
                <article class="section__image col-xl-8 col-lg-7 order-lg-1">
                    <div class="mr-lg-4 mt-lg-0 mt-5 d-lg-block d-none">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '375px',
                            width: '100%',
                            'background-color': '#edeef2'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                    <div class="mr-lg-4 mt-lg-0 mt-5 d-lg-none d-md-block">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '300px',
                            width: '100%',
                            'background-color': '#edeef2'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                </article>
            </div>
        </div>
    </article>
    <!-- odd section -->
    <article class="section px-4 py-5">
        <div class="container h-100">
            <div class="row h-100">
                <article class="section__content col-xl-4 col-lg-5">
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '50px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="4"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '100%',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <!-- section button -->
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '0',
                        height: '44px',
                        width: '50%',
                        'margin-top': '50px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                </article>
                <article class="section__image col-xl-8 col-lg-7">
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-lg-block d-none">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '375px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-lg-none d-md-block">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '300px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                </article>
            </div>
        </div>
    </article>
    <!-- last section -->
    <article class="last-section px-4 py-5">
        <article class="text-center">
            <ngx-skeleton-loader
                count="1"
                animation="progress"
                [theme]="{ 
                'border-radius': '4px',
                height: '16px',
                width: '45%',
                display: 'block',
                margin: 'auto',
                'margin-bottom': '15px',
                'background-color': '#E4E6ED'
                }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
                count="4"
                appearance="circle"
                animation="pulse"
                [theme]="{ 
                height: '2.25em',
                width: '2.25em',
                'margin': '0.5rem',
                'background-color': '#E4E6ED'
                }"
            ></ngx-skeleton-loader>
        </article>
        <div class="container h-100">
            <div class="row h-100">
            </div>
        </div>
    </article>
</section>

<section class="skeleton-loader d-md-none d-block">
    <!-- banner section -->
    <article class="banner">
        <ngx-skeleton-loader
            count="1"
            animation="pulse"
            [theme]="{ 
            'border-radius': '8px',
            height: '40vh',
            width: '100%',
            'background-color': '#E4E6ED'
            }"
        ></ngx-skeleton-loader>
    </article>
    <article class="banner__content py-5">
        <!-- banner header -->
        <div class="banner__header w-100 text-center mb-5">
            <ngx-skeleton-loader
            count="1"
            animation="progress"
            [theme]="{ 
            'border-radius': '8px',
            height: '60px',
            width: '65%',
            'background-color': '#E4E6ED'
            }"
            ></ngx-skeleton-loader>
        </div>
        <!-- banner description -->
        <div class="banner__description w-100 text-center mb-5">
            <ngx-skeleton-loader
            count="1"
            animation="progress"
            [theme]="{ 
            'border-radius': '4px',
            height: '18px',
            width: '80%',
            display: 'block',
            margin: 'auto',
            'margin-bottom': '15px',
            'background-color': '#E4E6ED'
            }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
            count="1"
            animation="progress"
            [theme]="{ 
            'border-radius': '4px',
            height: '18px',
            width: '50%',
            'background-color': '#E4E6ED'
            }"
            ></ngx-skeleton-loader>
        </div>
        <div class="banner__buttons row d-flex-center-center w-100">
            <div class="col-sm-8 col-10 p-0">
                <ngx-skeleton-loader
                count="1"
                animation="progress"
                [theme]="{
                'border-radius': '0',
                height: '44px',
                width: '100%',
                'background-color': '#E4E6ED'
                }"
                ></ngx-skeleton-loader>
            </div>
            <div class="col-sm-8 col-10 p-0">
                <ngx-skeleton-loader
                count="1"
                animation="progress"
                [theme]="{
                'border-radius': '0',
                height: '44px',
                width: '100%',
                'background-color': '#E4E6ED'
                }"
                ></ngx-skeleton-loader>
            </div>
        </div>
    </article>
    <!-- odd section -->
    <article class="section px-3 py-5">
        <div class="container h-100">
            <div class="row h-100">
                <article class="section__content col-xl-4 col-lg-5">
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '50px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="4"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '100%',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <!-- section button -->
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '0',
                        height: '44px',
                        width: '80%',
                        'margin-top': '50px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                </article>
                <article class="section__image col-xl-8 col-lg-7">
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-md-block d-none">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '300px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-md-none d-block">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '180px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                </article>
            </div>
        </div>
    </article>
    <!-- even section -->
    <article class="section section--even px-3 py-5">
        <div class="container h-100">
            <div class="row h-100">
                <article class="section__content col-xl-4 col-lg-5 order-lg-2">
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '50px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#edeef2'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="4"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '100%',
                        'background-color': '#edeef2'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#edeef2'
                        }"
                    ></ngx-skeleton-loader>
                    <!-- section button -->
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '0',
                        height: '44px',
                        width: '80%',
                        'margin-top': '50px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                </article>
                <article class="section__image col-xl-8 col-lg-7 order-lg-1">
                    <div class="mr-lg-4 mt-lg-0 mt-5 d-md-block d-none">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '300px',
                            width: '100%',
                            'background-color': '#edeef2'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                    <div class="mr-lg-4 mt-lg-0 mt-5 d-md-none d-block">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '180px',
                            width: '100%',
                            'background-color': '#edeef2'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                </article>
            </div>
        </div>
    </article>
    <!-- odd section -->
    <article class="section px-3 py-5">
        <div class="container h-100">
            <div class="row h-100">
                <article class="section__content col-xl-4 col-lg-5">
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '50px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="4"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '100%',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '8px',
                        height: '14px',
                        width: '85%',
                        'margin-bottom': '25px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                    <!-- section button -->
                    <ngx-skeleton-loader
                        count="1"
                        animation="progress"
                        [theme]="{ 
                        'border-radius': '0',
                        height: '44px',
                        width: '80%',
                        'margin-top': '50px',
                        'background-color': '#E4E6ED'
                        }"
                    ></ngx-skeleton-loader>
                </article>
                <article class="section__image col-xl-8 col-lg-7">
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-md-block d-none">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '300px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                    <div class="ml-lg-4 mt-lg-0 mt-5 d-md-none d-block">
                        <ngx-skeleton-loader
                            count="1"
                            animation="pulse"
                            [theme]="{ 
                            'border-radius': '0',
                            height: '180px',
                            width: '100%',
                            'background-color': '#E4E6ED'
                            }"
                        ></ngx-skeleton-loader>
                    </div>
                </article>
            </div>
        </div>
    </article>
    <!-- last section -->
    <article class="last-section px-3 py-5">
        <article class="text-center">
            <ngx-skeleton-loader
                count="1"
                animation="progress"
                [theme]="{ 
                'border-radius': '4px',
                height: '16px',
                width: '70%',
                display: 'block',
                margin: 'auto',
                'margin-bottom': '15px',
                'background-color': '#E4E6ED'
                }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
                count="4"
                appearance="circle"
                animation="pulse"
                [theme]="{ 
                height: '2.25em',
                width: '2.25em',
                'margin': '0.5rem',
                'background-color': '#E4E6ED'
                }"
            ></ngx-skeleton-loader>
        </article>
        <div class="container h-100">
            <div class="row h-100">
            </div>
        </div>
    </article>
</section>